import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/shared/shared.module';

export interface CloneDialogData {
  sourceName: string;
  existingNames: string[];
  title?: string;
  confirmLabel?: string;
  prefillSourceName?: boolean;
}

@Component({
    standalone: true,
    selector: 'app-report-template-clone-dialog',
    imports: [FormsModule, SharedModule],
    templateUrl: './report-template-clone-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./report-template-clone-dialog.component.scss']
})
export class ReportTemplateCloneDialogComponent implements OnInit {
  cloneName = '';

  get title(): string {
    return this.data.title ?? 'Clone Template';
  }

  get confirmLabel(): string {
    return this.data.confirmLabel ?? 'Clone';
  }

  get isDuplicate(): boolean {
    const trimmed = this.cloneName.trim().toLowerCase();
    if (trimmed === this.data.sourceName.trim().toLowerCase() && this.data.prefillSourceName) return false;
    return this.data.existingNames.some(n => n.toLowerCase() === trimmed);
  }

  get isValid(): boolean {
    return !!this.cloneName.trim() && !this.isDuplicate;
  }

  constructor(
    private dialogRef: MatDialogRef<ReportTemplateCloneDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: CloneDialogData
  ) {}

  ngOnInit(): void {
    this.cloneName = this.data.prefillSourceName ? this.data.sourceName : `${this.data.sourceName} - Copy`;
  }

  confirm(): void {
    if (!this.isValid) return;
    this.dialogRef.close(this.cloneName.trim());
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
